import { Team } from "../../types";

export const lec2Teams: Team[] = [
  {
    name: "G2",
    icon: "https://am-a.akamaihd.net/image?resize=60:60&f=http%3A%2F%2Fstatic.lolesports.com%2Fteams%2FG2-FullonDark.png",
    seed: 1,
  },
  {
    name: "FNC",
    icon: "https://am-a.akamaihd.net/image?resize=60:60&f=http%3A%2F%2Fstatic.lolesports.com%2Fteams%2F1631819669150_fnc-2021-worlds.png",
    seed: 2,
  },
  {
    name: "XL",
    icon: "https://am-a.akamaihd.net/image?resize=60:60&f=http%3A%2F%2Fstatic.lolesports.com%2Fteams%2FExcel_FullColor2.png",
    seed: 3,
  },
  {
    name: "HRT",
    icon: "https://am-a.akamaihd.net/image?resize=60:60&f=http%3A%2F%2Fstatic.lolesports.com%2Fteams%2F1672933861879_Heretics-Full-Color.png",
    seed: 4,
  },
  {
    name: "BDS",
    icon: "https://am-a.akamaihd.net/image?resize=60:60&f=http%3A%2F%2Fstatic.lolesports.com%2Fteams%2F1641292031788_Team_BDSlogo_square.png",
    seed: 5,
  },
  {
    name: "SK",
    icon: "https://am-a.akamaihd.net/image?resize=60:60&f=http%3A%2F%2Fstatic.lolesports.com%2Fteams%2F1643979272144_SK_Monochrome.png",
    seed: 6,
  },
  {
    name: "MAD",
    icon: "https://am-a.akamaihd.net/image?resize=60:60&f=http%3A%2F%2Fstatic.lolesports.com%2Fteams%2F1631819614211_mad-2021-worlds.png",
    seed: 7,
  },
  {
    name: "KOI",
    icon: "https://am-a.akamaihd.net/image?resize=60:60&f=http%3A%2F%2Fstatic.lolesports.com%2Fteams%2F1673718797685_image.webp",
    seed: 8,
  },
  {
    name: "AST",
    icon: "https://am-a.akamaihd.net/image?resize=60:60&f=http%3A%2F%2Fstatic.lolesports.com%2Fteams%2FAST-FullonDark.png",
    seed: 9,
  },
  {
    name: "VIT",
    icon: "https://am-a.akamaihd.net/image?resize=60:60&f=http%3A%2F%2Fstatic.lolesports.com%2Fteams%2F1675865863968_Vitality_FullColor.png",
    seed: 10,
  },
];
